export default __webpack_public_path__ + "static/media/Streaming-Media-pos.f142f46f.svg";